import "../helpers/api_helper";
import axios from "axios";

const base = () => axios.defaults.baseURL || "";

function authHeaders() {
  const token = localStorage.getItem("accessToken");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

/** Response interceptor returns `response.data` directly (see api_helper). */
export async function getServiceRuleConfig() {
  return axios.get(`${base()}merchant/service-rule-config`, {
    headers: { ...authHeaders() },
  });
}

export async function patchServiceRuleConfig(body) {
  return axios.patch(`${base()}merchant/service-rule-config`, body, {
    headers: { ...authHeaders(), "Content-Type": "application/json" },
  });
}

export async function patchMerchantPercentage(percentage) {
  return axios.patch(
    `${base()}merchant/merchant-percentage`,
    { percentage },
    {
      headers: { ...authHeaders(), "Content-Type": "application/json" },
    }
  );
}

export async function createVoucher(body) {
  return axios.post(`${base()}merchant/vouchers`, body, {
    headers: { ...authHeaders(), "Content-Type": "application/json" },
  });
}

export async function listVouchers(page = 0, size = 20) {
  return axios.get(
    `${base()}merchant/vouchers?page=${page}&size=${size}`,
    { headers: { ...authHeaders() } }
  );
}

export async function revokeVoucher(id) {
  return axios.put(
    `${base()}merchant/vouchers/${id}/revoke`,
    {},
    { headers: { ...authHeaders() } }
  );
}
